import { buildCharacterArbitrary } from './_internals/builders/CharacterArbitraryBuilder.js';
function identity(v) {
    return v;
}
export function char() {
    return buildCharacterArbitrary(0x20, 0x7e, identity, identity);
}
